module.exports = __webpack_public_path__ + "img/gnjs3.f82cbf03.png";